import api from '@/api'
import LojaSearchSelect from './LojaSearchSelect.vue'
import {
  calcularPaginasVisiveis,
  formatToolName,
  formatarTempo,
} from './helpers'

export default {
  name: 'RelatoriosIA',
  components: {
    LojaSearchSelect,
  },
  data() {
    return {
      abaAtiva: 'execucoes',
      consumoInicializado: false,
      filtrosPeriodo: {
        startDate: '',
        endDate: '',
        lojaId: '',
      },
      filtros: {
        pipelineId: '',
        toolName: '',
        status: '',
        oportunidadeId: '',
      },
      metricas: {},
      execucoes: {
        data: [],
        current_page: 1,
        last_page: 1,
        per_page: 20,
        total: 0,
        from: 0,
        to: 0,
        prev_page_url: null,
        next_page_url: null,
      },
      pipelines: [],
      toolNames: [],
      detalhesExecucao: null,
    }
  },
  computed: {
    paginasVisiveis() {
      return calcularPaginasVisiveis(
        this.execucoes.current_page,
        this.execucoes.last_page
      )
    },
    filtrosPeriodoFormatados() {
      const formatados = { ...this.filtrosPeriodo }
      formatados.lojaId = this.getLojaIdAtiva()
      if (formatados.startDate) {
        formatados.startDate = formatados.startDate + ' 00:00:00'
      }
      if (formatados.endDate) {
        formatados.endDate = formatados.endDate + ' 23:59:59'
      }
      return formatados
    },
  },
  mounted() {
    this.inicializarFiltros()
    this.carregarDadosIniciais()
  },
  methods: {
    inicializarFiltros() {
      const hoje = new Date()
      const trintaDiasAtras = new Date(hoje.getTime() - 30 * 24 * 60 * 60 * 1000)

      this.filtrosPeriodo.endDate = hoje.toISOString().split('T')[0]
      this.filtrosPeriodo.startDate = trintaDiasAtras.toISOString().split('T')[0]
      this.filtrosPeriodo.lojaId = window.lojaId || ''
    },
    getLojaIdAtiva() {
      return this.filtrosPeriodo.lojaId || window.lojaId
    },
    selecionarAba(aba) {
      this.abaAtiva = aba
      if (aba === 'consumo') {
        if (!this.consumoInicializado) {
          this.consumoInicializado = true
        } else {
          this.$nextTick(() => {
            this.$refs.consumoTab?.renderTodosGraficos?.()
          })
        }
      }
    },
    aplicarPeriodoELoja() {
      this.carregarToolNames()
      if (this.abaAtiva === 'execucoes') {
        this.aplicarFiltros()
      } else if (this.consumoInicializado && this.$refs.consumoTab) {
        this.$refs.consumoTab.carregarDados()
      }
    },
    async carregarDadosIniciais() {
      document.getElementById('overlayer-loading')?.classList.add('show-overlayer')

      try {
        await Promise.all([
          this.carregarPipelines(),
          this.carregarToolNames(),
          this.carregarMetricas(),
          this.carregarExecucoes(),
        ])
      } finally {
        document.getElementById('overlayer-loading')?.classList.remove('show-overlayer')
      }
    },
    async carregarPipelines() {
      try {
        const response = await api.get('/painel/oportunidades-pipelines', {
          params: {
            data: 1,
          },
        })

        this.pipelines = response.data
      } catch (error) {
        console.error('Erro ao carregar pipelines:', error)
      }
    },
    async carregarToolNames() {
      try {
        const response = await api.get('/painel/ia/relatorios/tool-names', {
          params: { lojaId: this.getLojaIdAtiva() },
        })
        this.toolNames = response.data
      } catch (error) {
        console.error('Erro ao carregar ferramentas:', error)
      }
    },
    async carregarMetricas() {
      try {
        const response = await api.get('/painel/ia/relatorios/metricas', {
          params: {
            lojaId: this.getLojaIdAtiva(),
            ...this.getFiltrosFormatados(),
          },
        })
        this.metricas = response.data
      } catch (error) {
        console.error('Erro ao carregar métricas:', error)
        window.showToastDanger?.('body', 'Erro ao carregar métricas')
      }
    },
    async carregarExecucoes(pagina = 1) {
      try {
        const response = await api.get('/painel/ia/relatorios/execucoes', {
          params: {
            lojaId: this.getLojaIdAtiva(),
            page: pagina,
            perPage: 20,
            ...this.getFiltrosFormatados(),
          },
        })
        this.execucoes = response.data.execucoes
      } catch (error) {
        console.error('Erro ao carregar execuções:', error)
        window.showToastDanger?.('body', 'Erro ao carregar execuções')
      }
    },
    async verDetalhes(id) {
      try {
        const response = await api.get(`/painel/ia/relatorios/execucao/${id}`, {
          params: { lojaId: this.getLojaIdAtiva() },
        })
        this.detalhesExecucao = response.data.execucao
        $('#modalDetalhes').modal('show')
      } catch (error) {
        console.error('Erro ao carregar detalhes:', error)
        window.showToastDanger?.('body', 'Erro ao carregar detalhes da execução')
      }
    },
    aplicarFiltros() {
      this.carregarMetricas()
      this.carregarExecucoes(1)
    },
    limparFiltros() {
      this.inicializarFiltros()
      this.filtros.pipelineId = ''
      this.filtros.toolName = ''
      this.filtros.status = ''
      this.filtros.oportunidadeId = ''
      this.aplicarFiltros()
    },
    carregarPagina(pagina) {
      if (pagina >= 1 && pagina <= this.execucoes.last_page) {
        this.carregarExecucoes(pagina)
      }
    },
    formatToolName,
    formatarTempo,
    formatarPeriodo() {
      if (!this.filtrosPeriodo.startDate || !this.filtrosPeriodo.endDate) return 'N/A'

      const inicio = new Date(this.filtrosPeriodo.startDate)
      const fim = new Date(this.filtrosPeriodo.endDate)

      return `${inicio.toLocaleDateString('pt-BR')} - ${fim.toLocaleDateString('pt-BR')}`
    },
    getFiltrosFormatados() {
      const filtrosFormatados = {
        ...this.filtros,
        startDate: this.filtrosPeriodo.startDate,
        endDate: this.filtrosPeriodo.endDate,
      }

      if (filtrosFormatados.startDate) {
        filtrosFormatados.startDate = filtrosFormatados.startDate + ' 00:00:00'
      }

      if (filtrosFormatados.endDate) {
        filtrosFormatados.endDate = filtrosFormatados.endDate + ' 23:59:59'
      }

      return filtrosFormatados
    },
    nomePipeline(id) {
      if (!id) return 'N/A'
      const pipeline = this.pipelines.find(item => item.id === id)
      return pipeline ? pipeline.value : id
    },
  },
}
